import { createSlice } from "@reduxjs/toolkit";
import { fetchAllLabours, fetchLabourById, addLabour, updateLabour, updateStatusInLabour, fetchLabourDropdownForForms } from "./thunk";

interface LabourState {
    labourList: any[];
    rowCount: number;
    loading: boolean;
    error: any;
    selectedLabour: any;
    labourDropdown: any[]; // Dropdown data for forms
}

const initialState: LabourState = {
    labourList: [],
    rowCount: 0,
    loading: false,
    error: null,
    selectedLabour: null,
    labourDropdown: [],
}

const labourSlice = createSlice({
    name: "labour",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllLabours.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllLabours.fulfilled, (state, action) => {
                state.loading = false;
                state.labourList = action.payload.data;
                state.rowCount = action.payload.rowCount;
                state.error = null;
            })
            .addCase(fetchAllLabours.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to fetch Labours"
            })
            .addCase(fetchLabourById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLabourById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedLabour = action.payload;
                state.error = null;
            })
            .addCase(fetchLabourById.rejected, (state, action) => {
                state.loading = false;
                const errorPayload = action.payload as any;
                state.error = typeof errorPayload === "string" 
                    ? errorPayload 
                    : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to fetch Labour by ID";
            })
            .addCase(addLabour.fulfilled, (state) => {
                state.error = null;
            })
            .addCase(addLabour.rejected, (state, action) => {
                state.loading = false;
                const errorPayload = action.payload as any;
                state.error = typeof errorPayload === "string" 
                    ? errorPayload 
                    : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to add Labour";
            })
            .addCase(updateLabour.fulfilled, (state) => {
                state.error = null;
            })
            .addCase(updateLabour.rejected, (state, action) => {
                state.loading = false;
                const errorPayload = action.payload as any;
                state.error = typeof errorPayload === "string" 
                    ? errorPayload 
                    : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to update Labour";
            })
            .addCase(updateStatusInLabour.fulfilled, (state, action) => {
                if (action.payload?.labour_id) {
                    state.labourList = state.labourList.map((labour) =>
                        labour.labour_id === action.payload.labour_id
                            ? { ...labour, is_active: action.payload.is_active }
                            : labour
                    );
                }
                state.error = null;
            })
            .addCase(updateStatusInLabour.rejected, (state, action) => {
                state.loading = false;
                const errorPayload = action.payload as any;
                state.error = typeof errorPayload === "string" 
                    ? errorPayload 
                    : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to update Labour status";
            })
            .addCase(fetchLabourDropdownForForms.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLabourDropdownForForms.fulfilled, (state, action) => {
                state.loading = false;
                state.labourDropdown = action.payload;
                state.error = null;
            })
            .addCase(fetchLabourDropdownForForms.rejected, (state, action) => {
                state.loading = false;
                const errorPayload = action.payload as any;
                state.error = typeof errorPayload === "string" 
                    ? errorPayload 
                    : errorPayload?.error || errorPayload?.message || action.error.message || "Failed to fetch Labour dropdown";
                state.labourDropdown = [];
            })
    }
})

export const { clearError } = labourSlice.actions;


export default labourSlice.reducer;